import preferenceCenterPermissionService from '../../services/toolbox/preference-center-permission-service';
//import { content } from "html2canvas/dist/types/css/property-descriptors/content"; TODO: what is this for?

const state = {
	permissionsList: [],
	privileges: [],
	rolesList: [],
	isEdited: false,
};

const mutations = {
	SET_ROLE_PERMISSION(state, payload) {
		state.rolesList = payload;
	},

	TOGGLE_PERMISSION_GROUP(
		state,
		{ roleListIndex, categoryIndex, permissionsIndex },
	) {
		state.isEdited = true;
		state.rolesList[roleListIndex].permissions[categoryIndex].permissions[
			permissionsIndex
		].activeIndicator =
			!state.rolesList[roleListIndex].permissions[categoryIndex].permissions[
				permissionsIndex
			].activeIndicator;
	},

	SET_PRIVILEGES(state, privileges) {
		state.privileges = privileges;
	},

	SET_USER_PERMISSIONS(state, payload) {
		state.permissionsList = payload;
	},

	PERMISSION_ISEDITED(state, value = false) {
		state.isEdited = value;
	},

	HAS_ACCESS_TO_CLIENT_CONNECT(state, data) {
		const permission = data.permission.permissions[data.permissionsIndex];

		if (
			permission.group === 'AccessToClientConnect' &&
			permission.activeIndicator === true
		) {
			let setGlobalAlertPreference = state.rolesList
				.find((el) => el.role === 'MarketingManager')
				.permissions.find((el) => el.category === 'ClientConnect')
				.permissions.find((el) => el.group === 'SetGlobalAlertPreferences');
			if (setGlobalAlertPreference.activeIndicator === true) {
				setGlobalAlertPreference.activeIndicator = false;
			}
		}
	},
};

const actions = {
	setRolePermission({ commit }, rolePermissions) {
		commit('SET_ROLE_PERMISSION', rolePermissions);
	},

	setUserPermission(context, userPermissions) {
		context.commit('SET_USER_PERMISSIONS', userPermissions);
	},

	togglePermissionGroup({ commit }, data) {
		commit('HAS_ACCESS_TO_CLIENT_CONNECT', data);
		commit('TOGGLE_PERMISSION_GROUP', data);
		commit('PERMISSION_ISEDITED', true);
	},

	setPrivileges({ commit }, rolePrivileges) {
		commit('SET_PRIVILEGES', rolePrivileges);
	},
};

const getters = {
	roleIsNotActive(state) {
		return (name) => state.permissionsList.findIndex((el) => el === name) < 0;
	},

	canChangePermission(state) {
		return (role, groupName) => {
			const privilege = collectPrivilege(state, role, groupName);
			return privilege === 'Sometimes';
		};
	},

	isReadOnlyPermission(state) {
		return () => {
			return (
				state.permissionsList.findIndex(
					(el) => el === 'SetPermissionsForAllShopMembers',
				) < 0
			);
		};
	},

	canDeleteContact(state) {
		return state.permissionsList.includes('DeleteContact');
	},

	canReassignLeadsToDifferentContact(state) {
		return state.permissionsList.includes('ReassignLeadsToDifferentContact');
	},
	// getters has be here because rootstate is 3rd acgument
	hasAccessToClientConnect(state, getters, rootState) {
		if (
			rootState.profile.roles.includes('BrokerOwner') ||
			!rootState.profile.roles.includes('MarketingManager')
		)
			return true;
		return state.rolesList
			.find((el) => el.role === 'MarketingManager')
			.permissions.find((el) => el.category === 'ClientConnect')
			.permissions.find((el) => el.group === 'AccessToClientConnect')
			.activeIndicator;
	},
	// getters has be here because rootstate is 3rd acgument
	hasAccessToFamb(state, getters, rootState) {
		if (!rootState.profile.roles.includes('LoanOfficer')) return false;
		return state.rolesList
			.find((el) => el.role === 'LoanOfficer')
			.permissions.find((el) => el.category === 'FindAMortgageBroker')
			.permissions.find((el) => el.group === 'ProfileOnFindAMortgageBroker')
			.activeIndicator;
	},
	// getters has be here because rootstate is 3rd acgument
	isPermissionActive(state, getters, rootState) {
		return (role, category, permissionGroup) => {
			if (rootState.profile.roles.includes('BrokerOwner')) return true;
			return state.rolesList
				.find((el) => el.role === role)
				.permissions.find((el) => el.category === category)
				.permissions.find((el) => el.group === permissionGroup).activeIndicator;
		};
	},

	canToggleGlobalAlertPreferences(state) {
		return (permissionGroup) => {
			if (
				permissionGroup === 'SetGlobalAlertPreferences' &&
				state.rolesList
					.find((el) => el.role === 'MarketingManager')
					.permissions.find((el) => el.category === 'ClientConnect')
					.permissions.find((el) => el.group === 'AccessToClientConnect')
					.activeIndicator === false
			) {
				return true;
			} else {
				return false;
			}
		};
	},
};

function collectPrivilege(state, role, groupName) {
	if (state.privileges.length > 0 && groupName !== 'AssignProcessors') {
		const privilegeRole = state.privileges.filter((el) => el.role === role)[0];
		if (privilegeRole.privileges) {
			const rolePrivileges = privilegeRole.privileges.filter(
				(el) => el.groupName === groupName,
			)[0];
			if (rolePrivileges) {
				return rolePrivileges.privilege;
			}
		}
	}
	return '';
}

export default {
	state,
	mutations,
	actions,
	getters,
};
